import React, { Component, Fragment } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Table } from "antd";
import dayjs from "dayjs";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PurchaseOrderActions from "@Actions/purchaseOrderActions";
import Constants, { toISTDate } from "@Apis/constants";
import H3Modal from "@Uilib/H3Modal";
import ViewPurchaseOrder from "@Components/Common/ViewPurchaseOrder";
import Helpers from "@Apis/helpers";
import H3Text from "@Uilib/h3Text";
import GRNActions from "@Actions/grnActions";
import { v4 as uuidv4 } from "uuid";
import AnalyticsActions from "@Actions/application/analyticsActions";
import HideValue from "../../../Common/RestrictedAccess/HideValue";
import "./style.scss";
import { GetPurchaseOrders } from '@Modules/purchase/purchaseOrder';

class VendorPurchaseOrders extends Component {
  constructor(props) {
    super(props);
    const { user, priceMasking, downloadDocument } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } =
      priceMasking;
    this.state = {
      currentPage: 1,
      startDate: dayjs().valueOf(),
      openSelectedDuration: dayjs().subtract(300, "d").valueOf(),
      closedSelectedDuration: "LAST 60 DAYS",
      openPurchaseOrderModal: false,
      openGRNModal: false,
      openGRNModalView: false,
      openUpdatePurchaseOrderModal: false,
      expandedRowKeys: [],
      productListColumns: [
        {
          title: "",
          render: (record) => (
            <Link to={`/approval?type=po&id=${record.po_id}`}>
              <div className="mobile-list__item">
                <div style={{ display: "flex" }}>
                  <H3Text
                    text={`#${record?.po_number}`}
                    className="mobile-list__item-number"
                  />
                  <div
                    className="mobile-list__item-status"
                    style={{
                      backgroundColor: Helpers.getStatusColor(record.status)
                        .color,
                    }}
                  >
                    {Helpers.getStatusColor(record.status).text?.toUpperCase()}
                  </div>
                </div>
                {record?.seller_info && (
                  <div className="mobile-list__item-info">
                    {`Vendor - ${record.seller_info?.seller_name}`}
                  </div>
                )}
                <H3Text
                  text={`Amount - ${this.props.MONEY(record?.po_grand_total || "0")}`}
                  className="mobile-list__item-info"
                />
                <H3Text
                  text={
                    <React.Fragment>
                      Receiving Status -&nbsp;
                      <span
                        style={{
                          color: Helpers.getStatusColor(
                            record?.po_receiving_status || "NOT_RECEIVED"
                          ).color,
                        }}
                      >
                        {Helpers.getStatusColor(
                          record?.po_receiving_status || "NOT_RECEIVED"
                        ).text?.toUpperCase()}
                      </span>
                    </React.Fragment>
                  }
                  className="mobile-list__item-info"
                />
                <H3Text
                  text={`Created by ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : "Unknown"} on ${toISTDate(record?.created_at).format("DD/MM/YYYY")}`}
                  className="mobile-list__item-footer"
                />
              </div>
            </Link>
          ),
          responsive: ["xs"],
        },
        {
          title: "PURCHASE ORDER #",
          responsive: ["sm", "md", "lg", "xxl"],
          dataIndex: "po_number",
        },
        {
          title: "ITEMS",
          responsive: ["sm", "md", "lg", "xxl"],
          render: (text, record) => record.purchase_order_lines?.length,
        },
        {
          title: "AMOUNT",
          responsive: ["sm", "md", "lg", "xxl"],
          render: (text, record) =>
            isDataMaskingPolicyEnable && isHideCostPrice ? (
              <HideValue
                showPopOver
                popOverMessage={"You don't have access to view amount"}
              />
            ) : (
              this.props.MONEY(
                record.po_grand_total || "0",
                record?.org_currency_info?.currency_code
              )
            ),
        },
        {
          title: "CREATED DATE",
          responsive: ["sm", "md", "lg", "xxl"],
          render: (text, record) => (
            <div>
              {toISTDate(record?.po_date).format("DD/MM/YYYY")}
              <H3Text
                text={
                  record?.created_by_info
                    ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}`
                    : "Unknown"
                }
                className="table-subscript"
              />
            </div>
          ),
        },
        {
          title: "STATUS",
          responsive: ["sm", "md", "lg", "xxl"],
          render: (item) => (
            <div
              className="qr__status"
              style={{
                backgroundColor: Helpers.getStatusColor(item.status).color,
              }}
            >
              {Helpers.getStatusColor(item.status).text}
            </div>
          ),
        },
        {
          title: "RECEIVING STATUS",
          responsive: ["sm", "md", "lg", "xxl"],
          render: (item) => (
            <div
              style={{
                color: Helpers.getStatusColor(item?.po_receiving_status).color,
              }}
            >
              {Helpers.getStatusColor(
                item?.po_receiving_status || "NOT_RECEIVED"
              ).text?.toUpperCase()}
            </div>
          ),
        },
        {
          title: "PAYMENT STATUS",
          responsive: ["sm", "md", "lg", "xxl"],
          render: (item) => (
            <div
              style={{
                color: Helpers.getStatusColor(item.payment_status || "NOT_PAID")
                  .color,
              }}
            >
              {Helpers.getStatusColor(
                item.payment_status
              ).text?.toUpperCase() || "NOT PAID"}
            </div>
          ),
        },
        {
          title: "",
          responsive: ["sm", "md", "lg", "xxl"],
          key: "action",
          className: "list__actions-column",
          render: (text, record) => {
            const { history, user } = this.props;
            return (
              <div
                className="list__actions"
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  className="list__actions-button"
                  onClick={() => {
                    history.push(`/approval?type=po&id=${record.po_id}`);
                    const { getPurchaseOrderById } = this.props;
                    getPurchaseOrderById(record.po_id);
                  }}
                >
                  View
                </div>
                <div
                  className="list__actions-button list__actions-button-download"
                  onClick={() => {
                    if (["ISSUED"].includes(record.status)) {
                      downloadDocument({
                        url: `${Constants.PURCHASE_ORDERS}/download?po_id=${record?.po_id}&tenant_id=${record?.tenant_id}&download_document_in_base_currency=false`,
                        document_type: "PURCHASE_ORDER",
                        document_number: record?.po_number,
                        key: uuidv4(),
                      });
                    }
                  }}
                >
                  <div
                    className={`roundIconButton ${!["ISSUED"].includes(record.status) ? "roundIconButtonDisabled" : ""}`}
                    style={{ marginLeft: "5px", marginRight: "5px" }}
                  >
                    <H3Text
                      text={<FontAwesomeIcon icon={faDownload} />}
                      className="action-button"
                    />
                  </div>
                </div>
              </div>
            );
          },
        },
      ],
      grnListColumns: [
        {
          title: "GRN ID",
          dataIndex: "grn_id",
        },
        {
          title: "Created Time",
          render: (text, record) =>
            `${toISTDate.utc(toISTDate(record.created_at).format("DD/MM/YYYY"), "DD/MM/YYYY").local().format("DD/MM/YYYY")}`,
        },
        {
          title: "Created By",
          dataIndex: "created_by",
        },
        {
          title: "Status",
          render: (item) => (
            <div
              className="qr__status"
              style={{
                backgroundColor: Helpers.getStatusColor(item.status).color,
              }}
            >
              {Helpers.getStatusColor(item.status).text}
            </div>
          ),
        },
        {
          title: "",
          key: "action",
          render: (text, record) => (
            <div
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                className="generic-view-button"
                onClick={() =>
                  this.setState({ openGRNModalView: true, selectedGRN: record })
                }
              >
                View
              </div>
            </div>
          ),
        },
      ],
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.isUserReady) {
      const { currentPage, isUserReady } = state;
      const { user, selectedSeller, getPurchaseOrdersV2 } = props;
      if (
        user?.tenant_info?.org_id &&
        selectedSeller?.tenant_seller_id &&
        !isUserReady
      ) {
        // getPurchaseOrders(
        //   user?.tenant_info?.org_id,
        //   user?.tenant_info?.tenant_id,
        //   selectedSeller?.tenant_seller_id,
        //   null,
        //   null,
        //   null,
        //   null,
        //   currentPage,
        //   10,
        //   "",
        //   null,
        //   null,
        //   "",
        //   "",
        //   "",
        //   ""
        // );
        getPurchaseOrdersV2({
          query: {
            org_id: user?.org_id,
            tenant_id: user?.tenant_info?.tenant_id,
            tenant_seller_id: selectedSeller?.tenant_seller_id,
            page: currentPage,
            limit: 10,
          },
        });
        return {
          ...state,
          isUserReady: true,
        };
      }
    }
    return state;
  }

  // handleClose(workflowSteps) {
  //   const {
  //     getPurchaseOrders,
  //     user,
  //     getPurchaseOrderByIdSuccess,
  //     getPurchaseOrderById,
  //     selectedPurchaseOrder,
  //     selectedSeller,
  //   } = this.props;
  //   const { currentPage } = this.state;
  //   this.setState({
  //     selectedPurchaseOrder: {
  //       ...selectedPurchaseOrder,
  //       workflow_steps: workflowSteps,
  //       status: "SENT_FOR_APPROVAL",
  //     },
  //   });
  //   getPurchaseOrderById(selectedPurchaseOrder?.po_id);
  //   getPurchaseOrderByIdSuccess(null);
  //   getPurchaseOrders(
  //     user?.tenant_info?.org_id,
  //     user?.tenant_info?.tenant_id,
  //     selectedSeller?.tenant_seller_id,
  //     null,
  //     null,
  //     null,
  //     null,
  //     currentPage,
  //     10,
  //     "",
  //     null,
  //     null,
  //     "",
  //     "",
  //     "",
  //     ""
  //   );
  // }

  render() {
    const {
      purchaseOrdersV2,
      getPurchaseOrdersV2Loading,
      user,
      selectedSeller,
      getPurchaseOrdersV2,
    } = this.props;
    const {
      currentPage,
      productListColumns,
      openPurchaseOrderModal,
      showNewGrnForm,
      selectedPoForGrn,
    } = this.state;
    return (
      <Fragment>
        <div className="vendor-pos__wrapper">
          <div className="ant-row">
            <div className="ant-col-md-24 ant-col-xs-24">
              <div className="generic-table-container">
                <Table
                  title={() => (
                    <div className="purchase-orders__table-header">
                      {`${purchaseOrdersV2 && purchaseOrdersV2.count ? purchaseOrdersV2.count : "0"} Purchase Orders`}
                    </div>
                  )}
                  loading={getPurchaseOrdersV2Loading}
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={productListColumns}
                  rowKey="po_id"
                  dataSource={
                    purchaseOrdersV2 && purchaseOrdersV2.purchase_order
                      ? purchaseOrdersV2.purchase_order
                      : []
                  }
                  pagination={
                    purchaseOrdersV2 && purchaseOrdersV2.count > 10
                      ? {
                        defaultCurrent: 1,
                        current: currentPage,
                        total: purchaseOrdersV2 ? purchaseOrdersV2.count : 0,
                        pageSize: 10,
                        onChange: (page) => {
                          getPurchaseOrdersV2({
                            query: {
                              org_id: user?.org_id,
                              tenant_id: user?.tenant_info?.tenant_id,
                              tenant_seller_id: selectedSeller?.tenant_seller_id,
                              page: page,
                              limit: 10,
                            },
                          });
                          this.setState({ currentPage: page });
                        },
                        position: ["bottomLeft"],
                        showTotal: (tot, range) =>
                          `${range[0]}-${range[1]} of ${tot} items`,
                        showSizeChanger: false,
                      }
                      : false
                  }
                  rowClassName={(record) =>
                    !record.is_active ? "inactive_record" : ""
                  }
                />
              </div>
            </div>
          </div>
        </div>
        {/* <H3Modal
          onClose={() => this.setState({ openPurchaseOrderModal: false })}
          isOpen={openPurchaseOrderModal}
          title={`Purchase Order #${selectedPurchaseOrder ? selectedPurchaseOrder.po_id : ""}`}
          showHeader
        >
          <ViewPurchaseOrder
            selectedPurchaseOrder={selectedPurchaseOrder}
            handleClose={(workflowSteps) => this.handleClose(workflowSteps)}
          />
        </H3Modal> */}
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers,
  PurchaseOrderReducers,
  TenantReducers,
  GRNReducers,
  SellerReducers,
  GetPurchaseOrders,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  grnData: PurchaseOrderReducers.grnData,
  getGRNLoading: GRNReducers.getGRNLoading,
  getPurchaseOrderByIdLoading:
    PurchaseOrderReducers.getPurchaseOrderByIdLoading,
  selectedPurchaseOrder: PurchaseOrderReducers.selectedPurchaseOrder,
  selectedSeller: SellerReducers.selectedSeller,
  priceMasking: UserReducers.priceMasking,
  purchaseOrdersV2: GetPurchaseOrders.data,
  getPurchaseOrdersV2Loading: GetPurchaseOrders.loading,
});
const mapDispatchToProps = (dispatch) => ({
  getGRN: (page, poId) => dispatch(GRNActions.getGRN(page, poId)),
  getPurchaseOrderById: (poId) =>
    dispatch(PurchaseOrderActions.getPurchaseOrderById(poId)),
  getPurchaseOrderByIdSuccess: (selectedPurchaseOrder) =>
    dispatch(
      PurchaseOrderActions.getPurchaseOrderByIdSuccess(selectedPurchaseOrder)
    ),
  downloadDocument: (payload, document) =>
    dispatch(AnalyticsActions.downloadDocument(payload, document)),
  getPurchaseOrdersV2: (payload, callback) => dispatch(GetPurchaseOrders.actions.request(payload, callback)),
});

VendorPurchaseOrders.propTypes = {
  user: PropTypes.any,
  history: PropTypes.func,
  getPurchaseOrderById: PropTypes.func,
  getPurchaseOrderByIdSuccess: PropTypes.func,
  selectedPurchaseOrder: PropTypes.any,
  selectedSeller: PropTypes.any,
  MONEY: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(VendorPurchaseOrders));
